/**
 * 学校検索ページ用のJSファイル
 */
export const schoolSearch = () => {
  const button = document.getElementById( 'js-search' );
  const hideEl = document.querySelector( '.p-form-item.js-hide' );

  hideEl.style.display = 'none';

  button.addEventListener( 'click', () => {
    hideEl.style.display = 'block';
    return false;
  } );
}
